import './_booking-box.scss';
import './_sectra-booking.scss';

export const sectrabooking = {

};